export default "__VITE_ASSET__CEmXn34k__"